import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "tw-relative" };
const _hoisted_2 = {
    key: 0,
    class: "tw-w-full tw-px-4 tw-pt-3 tw-flex tw-justify-end sm:tw-hidden"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CircleX = _resolveComponent("CircleX");
    const _component_SidebarLiveNavigation = _resolveComponent("SidebarLiveNavigation");
    return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        _createElementVNode("div", {
            class: _normalizeClass(["tw-w-full tw-h-[calc(100vh-170px)] tw-overflow-auto sm:tw-block tw-bg-background tw-z-[98]", {
                    'tw-hidden': !$setup.catsidebar.isSidebarVisible,
                    'tw-fixed tw-left-0 tw-top-20 tw-z-50': $setup.catsidebar.isSidebarVisible,
                }])
        }, [
            ($setup.catsidebar.isSidebarVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("button", {
                        class: "tw-text-[var(--foreground)] hover:tw-opacity-80",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => ($setup.catsidebar.toggleSidebar && $setup.catsidebar.toggleSidebar(...args)))
                    }, [
                        _createVNode(_component_CircleX, { class: "tw-w-6 tw-h-6" })
                    ])
                ]))
                : _createCommentVNode("", true),
            _createVNode(_component_SidebarLiveNavigation, {
                liveGameCategories: $props.liveGameCategories,
                selectedCategory: $props.selectedCategory,
                onCloseSidebar: _cache[1] || (_cache[1] = ($event) => ($setup.catsidebar.isSidebarVisible = false)),
                onCategoryChanged: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('category-changed')))
            }, null, 8, ["liveGameCategories", "selectedCategory"])
        ], 2)
    ]));
}
